import { httpPostMultipart } from "../httpService/httpService";
import { UploadProtocolImageProps, UploadRegistrationCardFileProps } from "./types/uploadFilesServiceProps";

export const uploadProtocolImage = async (props: UploadProtocolImageProps) => {
    const formData = new FormData();
    formData.append('File', props.file, props.file.name);
    formData.append('IsLandslide', JSON.stringify(props.isLandslide));
    formData.append('IdNum', props.idNum.toString());
    formData.append('WaitingRoomGlobalId', props.waitingRoomGlobalId);

    return new Promise((resolve, reject) => {
        httpPostMultipart(`${props.apiBase}/upload-protocol-images`, formData, props.handleOnUploadProgress)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const uploadRegistrationCardFile = async (props: UploadRegistrationCardFileProps) => {
    const formData = new FormData();
    formData.append('File', props.file, props.file.name);
    formData.append('IsLandslide', JSON.stringify(props.isLandslide));
    formData.append('IdNum', props.idNum.toString());
    formData.append('WaitingRoomGlobalId', props.waitingRoomGlobalId);
    formData.append('RasterType', props.rasterType);
    formData.append('Folder', props.folder);
    formData.append('MonitoringType', props.monitoringType);
    if (props.idx !== undefined && props.idx !== null) {
        formData.append('Idx', props.idx.toString());
    }

    return new Promise((resolve, reject) => {
        httpPostMultipart(`${props.apiBase}/upload-registration-card-file`, formData, props.handleOnUploadProgress)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}